import React, { useCallback } from 'react';

import ConfirmationDialog from 'components/dialog/ConfirmationDialog.component';
import call from 'utils/functions/call.util';

const MESSAGE_STYLE = Object.freeze({ color: '#565656' });
const TITLE = 'Refund or edit Error';

const CashupLogItemErrorModal = ({ message, onClose, onRequestClose }) => {
  const handleOk = useCallback(() => {
    call(`ConfirmationDialog.onRequestClose`, onRequestClose);
    call(`ConfirmationDialog.onClose`, onClose);
  }, [onClose, onRequestClose]);

  return (
    <ConfirmationDialog hideLeft rightButtonText="OK" onCancel={handleOk} onRight={handleOk} title={TITLE}>
      <p data-bem="CashupLogItemErrorModal__message" style={MESSAGE_STYLE}>
        {message}
      </p>
    </ConfirmationDialog>
  );
};

// noinspection JSUnusedGlobalSymbols
export default CashupLogItemErrorModal;
